import { render, staticRenderFns } from "./ListaClientes.vue?vue&type=template&id=09d6758b&scoped=true&"
import script from "./ListaClientes.vue?vue&type=script&lang=js&"
export * from "./ListaClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d6758b",
  null
  
)

export default component.exports